import React from 'react';

import { styled } from '@mui/material';

import useMathJaxScriptLoader from '~/hooks/useMathJaxScriptLoader';

//NOTE!!!!! use useMathJaxScriptLoader hook to load script
const MathJaxBlock = ({ children, hasFormula }) => {
  const nodeRef = useMathJaxScriptLoader(!hasFormula);

  return <Container ref={nodeRef}>{children}</Container>;
};

export default MathJaxBlock;

const Container = styled('div')`
  & mjx-container {
    &:focus {
      outline: none;
    }

    & svg {
      max-width: 100%;
    }
  }

  & mjx-container[jax='SVG'][display='true'] {
    background: ${({ theme }) => theme.palette.secondary.light};
    padding-top: 18px;
    padding-bottom: 18px;
    margin-top: 18px;
    margin-bottom: 18px;
    border-radius: 5px;
  }
`;
